import { Module } from 'vuex'
import _ from 'lodash'

import { PTRootState } from '@pt/store/index.type'
import { searchConfig, TableDataConfig } from '@pt/api/assets/index.type'
import {
  ResourceState,
  assetFontListItem,
} from '@pt/store/assets/resource.type'
// import { assetsList } from '@pt/api/assets/index'
import { assetsList } from '@pt/api/assets'

const assetsResourceModule: Module<ResourceState, PTRootState> = {
  namespaced: true,

  state: {
    // query: {},
    assetFontList: [],
    list: [],
    listItem: {},
    activeIndex: 0,
    total: 0,
    loading: false,
    isLast: false,
    isFirst: false,
  },

  mutations: {
    setActiveIndex(state, index: number) {
      state.activeIndex = index
    },
    setQuery(state, queryItem: searchConfig) {
      // state.query = { ...queryItem }
    },
    setList(state, arr: TableDataConfig[]) {
      state.list = arr
    },
    setTotal(state, total: number) {
      state.total = total
    },
    setListItem(state, item: TableDataConfig) {
      state.listItem = item
    },
    setLoading(state, val: boolean) {
      state.loading = val
    },
    setIsLast(state, val: boolean) {
      state.isLast = val
    },
    setIsFirst(state, val: boolean) {
      state.isFirst = val
    },
  },

  actions: {
    async getPreviousItem({ state, commit, dispatch }) {
      await commit('setActiveIndex', state.activeIndex - 1)
      await commit('setListItem', state.list[state.activeIndex])
      dispatch('geLastAddFirstItem')
      await commit('setLoading', false)
      // if (state.activeIndex === 0) {
      //   try {
      //     await commit('setQuery', {
      //       ...state.query,
      //       page: state.query.page - 1,
      //     })
      //     const res = await assetsList(state.query)
      //     if (!res.data.code) {
      //       await commit('setList', _.get(res, 'data.data.list') || [])
      //       await commit('setActiveIndex', state.list.length - 1)
      //       await commit('setListItem', state.list[state.activeIndex])
      //     }
      //   } catch (e) {
      //     await commit('setLoading', false)
      //     console.warn(e)
      //   }
      // } else {
      //   await commit('setActiveIndex', state.activeIndex - 1)
      //   await commit('setListItem', state.list[state.activeIndex])
      //   dispatch('geLastAddFirstItem')
      //   await commit('setLoading', false)
      // }
      // dispatch('geLastAddFirstItem')
      // await commit('setLoading', false)
    },
    async getNextItem({ state, commit, dispatch }) {
      await commit('setActiveIndex', state.activeIndex + 1)
      await commit('setListItem', state.list[state.activeIndex])
      dispatch('geLastAddFirstItem')
      await commit('setLoading', false)
      // 最后项
      // if (state.activeIndex === state.list.length - 1) {
      //   try {
      //     await commit('setQuery', {
      //       ...state.query,
      //       page: state.query.page + 1,
      //     })
      //     const res = await assetsList(state.query)
      //     if (!res.data.code) {
      //       await commit('setList', _.get(res, 'data.data.list') || [])
      //       await commit('setActiveIndex', 0)
      //       await commit('setListItem', state.list[state.activeIndex])
      //     }
      //   } catch (e) {
      //     await commit('setLoading', false)
      //     console.warn(e)
      //   }
      // } else {
      //   await commit('setActiveIndex', state.activeIndex + 1)
      //   await commit('setListItem', state.list[state.activeIndex])
      //   dispatch('geLastAddFirstItem')
      //   await commit('setLoading', false)
      // }
      // dispatch('geLastAddFirstItem')
      // await commit('setLoading', false)
    },
    async geLastAddFirstItem({ state, commit }) {
      if (state.list.length === 1) {
        commit('setIsFirst', true)
        commit('setIsLast', true)
      } else if (state.activeIndex === 0) {
        commit('setIsFirst', true)
        commit('setIsLast', false)
      } else if (state.activeIndex === state.list.length - 1) {
        commit('setIsFirst', false)
        commit('setIsLast', true)
      } else {
        commit('setIsLast', false)
        commit('setIsFirst', false)
      }
      // if (state.activeIndex === 0 && state.query.page === 1) {
      //   commit('setIsFirst', true)
      // } else if (
      //   state.query.page * state.query.page_size > state.total &&
      //   state.activeIndex === state.list.length - 1
      // ) {
      //   commit('setIsLast', true)
      // } else {
      //   commit('setIsLast', false)
      //   commit('setIsFirst', false)
      // }
    },
    getUpdateListItem({ state, commit }, list: TableDataConfig) {
      const arr = _.map(state.list, (item) => {
        if (item.id === list.id) {
          item = { ...list }
        }
        return item
      })
      commit('setList', arr)
      commit('setListItem', state.list[state.activeIndex])
    },

    async getAssetFontList({ state }) {
      const res = await assetsList({
        page: 1,
        page_size: 1000,
        types: ['font'],
        formats: ['ttf', 'otf'],
      })
      const list = _.get(res, 'data.data.list') || []
      const returnList: assetFontListItem[] = []
      _.map(list, (item) => {
        const payload = JSON.parse(item.payload)
        returnList.push({
          id: item.id,
          label: payload.postscript_name || '',
          svg: item.cover_url,
          url: item.full_url,
          value: item.id + '|' + payload.postscript_name,
        })
      })
      state.assetFontList = returnList
      return returnList
    },
  },
}

export default assetsResourceModule
